import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import FileUpload from "../../../components/others/FileUploader/FileUploader";
import LavorisService from "../../../services/LavorisService";
import { PillButton } from "../../../components/others/PillButton";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import StyledWrapper from "./style";
import Textarea from "../../../components/others/Textarea/Textarea";
import { PatientBasicInfo } from "../../../components/others/PatientBasicInfo";
import { SlotsOption } from "../requestTurn/requestedTurn.type";
import SearchSelectFetch from "../../../components/others/SearchFetch";
import {
  ExamDetails,
  MoldeDetails,
  PracticesPillows,
} from "../AppointmentMetadata";
import {
  fetchAndFilterMoldes,
  fetchAndFilterPractices,
} from "../requestTurn/utils";
import { RootState } from "../../../store/combineReducer";
import {
  AppointmentMetadata,
  GetOneAppointmentResponseService,
  Practice,
  EditTurnResponseService,
  CreateTurnResponseService,
} from "../../../services/TurnServices/Turns.type";
import { useFetchOne, useModal } from "../../../hooks";
import OptionsFailedAlert from "../../../components/others/OptionsFailed";
import { EditTurnType } from "./types";
import { AppointmentsDatePicker } from "../../../components/others/AppointmentDatePicker";
import {
  getTimesBySlotsOptions,
  getAppointmentToUpdateInfo,
  isSameDate,
  checkRulesBeforeUpdate,
} from "./utils";
import { ErrorWarningModal } from "../../../components/others/ErrorWarningModal";
import { SuccessModal } from "../../../components/others/SuccessModal";
import { DatePicker } from "../../../components/others/DatePicker/index";
import { SelectedFiles } from "../../../components/others/FileUploader/FileUploader.types";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useAlert } from "../../../hooks/useAlert";
import { getErrorMessage } from "../../../utils";
import DownloadButton from "../../../components/others/DownloadButton/downloadButton";
import InputRadioCM from "../../../components/others/InputCM/inputCM";
const WARNING = "warning";
const SUCCESS = "successEdition";

type TProps = {
  refreshFunction?: Function;
  isApplicant?: boolean;
};

export default function EditTurnForm({ refreshFunction, isApplicant }: TProps) {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    resetField,
    setValue,
    getValues,
    reset: resetForm,
  } = useForm<EditTurnType>({
    mode: "all",
  });

  const { closeModal, isActive, openModal } = useModal();
  const { showAlert } = useAlert();
  const [successMessages, setSuccessMessages] = useState({
    title: "",
    subTitle: "",
  });
  const reduxStore = useSelector((state: RootState) => state.user);
  const chosenRole: string = reduxStore?.currentRole;
  const { currentCompany, companies } = useSelector(
    (state: RootState) => state.user,
  );
  const [slotsOptions, setSlotsOptions] = useState<SlotsOption[]>([]);
  const [selectionChanged, setSelectionChanged] = useState(false);
  // const [optionFailed, setOptionFailed] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | null>(
    null,
  );
  const afterFetch = (appointment: GetOneAppointmentResponseService) => {
    resetForm(getAppointmentToUpdateInfo(appointment), {
      keepDefaultValues: true,
    });
  };

  const appointment = useFetchOne<GetOneAppointmentResponseService>(
    "appointments",
    searchParams.get("rowId"),
    afterFetch,
  );

  
  const patientType = appointment?.patient?.type || "";

  const [molde, exam, practicesSelected, date] = watch([
    "molde",
    "exam",
    "practicesSelected",
    "date",
  ]);

  const LavorisInstance = LavorisService.getInstance();

  // const calculateSlots = () => {
  //   LavorisInstance.TurnServices.getTurnSlots({
  //     exam: exam?.id,
  //     molde: molde?.id,
  //     practices: practicesSelected?.map((p) => p.id).join(","),
  //   })
  //     .then((response) => {
  //       if (response?.availability.length === 0) {
  //         setSlotsOptions([]);
  //         setOptionFailed(true);
  //       } else {
  //         setSlotsOptions(response?.availability);
  //         setOptionFailed(false);
  //       }
  //     })
  //     .catch((err) => {
  //       //console.log(err)
  //       setSlotsOptions([]);
  //       setOptionFailed(true);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //       if (!selectionChanged) setSelectionChanged(true);
  //       else {
  //         resetField("date");
  //         resetField("hour");
  //       }
  //     });
  // };

  // useEffect(() => {
  //   if (exam?.id || molde?.id || practicesSelected?.length > 0) {
  //     calculateSlots();
  //   } else {
  //     //setOptionFailed(false);
  //     setSlotsOptions([]);
  //     resetForm();
  //   }
  // }, [exam?.id, molde?.id, practicesSelected?.length, setSlotsOptions]);

  // const fechasUnicas: string[] = slotsOptions.reduce(
  //   (fechas: string[], obj) => {
  //     if (!fechas.includes(obj.date)) {
  //       fechas.push(obj.date);
  //     }
  //     return fechas;
  //   },
  //   [],
  // );

  // const fechasUnicasDate: string[] = fechasUnicas.map((fecha: string) => {
  //   let formatted = fecha.split("/");
  //   return formatted[2] + "-" + formatted[1] + "-" + formatted[0];
  // });

  const id = searchParams.get("rowId");
  const onSubmit = async (data: EditTurnType) => {
    try {
      if (!data.practiceSelector && !data.exam && !data.molde && (!data.practicesSelected || data.practicesSelected.length === 0)) {
        throw new Error("No se puede editar sin colocar ningún estudio");
      }
      setIsLoading(true);
      // checkRulesBeforeUpdate(data, appointment);



      //TODO: Handle Error
      if (!id) return console.log("Search param failed");

      const metadata: AppointmentMetadata = {
        exam: data.exam?.id,
        molde: data.molde?.id,
        practices: data.practicesSelected?.map((p) => p.id),
      };

      const partialSubmitData = {
        observations: data.comments,
        metadata,
        has_cm: data.has_cm === 'Si' ? true : false,
        professional_cm: data.professional_cm || null,
        professional_license_cm: data.professional_license_cm || null,
        cm_date: data.cm_date || null,
        cm_days: data.cm_days || null
      };



      await LavorisInstance.TurnServices.UpdateToRequest(
        partialSubmitData,
        id,
      )

      const filesToUpload = selectedFiles?.profileImages ?? [];
      if (filesToUpload.length > 0) {
        await Promise.all(filesToUpload.map((file) => uploadFile(id, file)));
      }

      // setSuccessMessages({
      //   title: "La edición se solicitó con éxito.",
      //   subTitle: "En las próximas horas se te informará la fecha y hora de turno.",
      // });
      // openModal(SUCCESS);     
      refreshFunction?.();
      // if (selectionChanged) {
      //   return LavorisInstance.TurnServices.UpdateToRequest(
      //     partialSubmitData,
      //     id,
      //   )
      //     .then((res) => {
      //       if (selectedFiles?.profileImages[0]) {
      //         return uploadFile(id, selectedFiles.profileImages[0]).then(
      //           () => res as CreateTurnResponseService,
      //         );
      //       }
      //       return res as CreateTurnResponseService;
      //     })
      //     .then(() => {
      //       setIsLoading(false);
      //       setSuccessMessages({
      //         title: "La edición se solicitó con éxito.",
      //         subTitle:
      //           "En las próximas horas se te informará la fecha y hora de turno.",
      //       });
      //       openModal(SUCCESS);
      //       refreshFunction && refreshFunction();
      //     });
      // }

      // const shouldFindSlots = Boolean(data.date && data.hour);

      // const slotsOption =
      //   shouldFindSlots &&
      //   slotsOptions.find(
      //     (option) =>
      //       isSameDate(data.date!, option.date) &&
      //       option.time === data.hour?.value,
      //   );

      // if (slotsOption) {
      //   return LavorisInstance.TurnServices.EditTurnService(
      //     {
      //       ...partialSubmitData,
      //       slots: slotsOption.slots,
      //     },
      //     id,
      //   )
      //     .then((res) => {
      //       if (selectedFiles?.profileImages[0]) {
      //         return uploadFile(id, selectedFiles.profileImages[0]).then(
      //           () => res as EditTurnResponseService,
      //         );
      //       }
      //       return res as EditTurnResponseService;
      //     })
      //     .then(() => {
      //       setIsLoading(false);
      //       setSuccessMessages({
      //         title: "Es tuno se editó con éxito.",
      //         subTitle:
      //           "Se envió un nuevo mail al paciente para que confirme su asistencia.",
      //       });
      //       openModal(SUCCESS);
      //       refreshFunction && refreshFunction();
      //     });
      // }

      // throw new Error("local");
    } catch (err: any) {
      console.log(err)
      if (err.message === 'No se puede editar sin colocar ningún estudio') {
        showAlert(getErrorMessage({ title: 'Es requerido solicitar algun exámen o práctica', err }))
      } else {
        showAlert(getErrorMessage({ title: 'No se pudo realizar la edición del turno.', err }))
      }
    } finally {
      setIsLoading(false);
    }
  };





  ///Funciones para la carga de archivos
  const updateUploadedFiles = (files: File[]) => setSelectedFiles({ ...selectedFiles, profileImages: files });

  const uploadFile = async (appointmentId: string, selectedFile: File) => {
    await LavorisInstance.TurnServices.addFile(
      { file: selectedFile },
      appointmentId,
    ).catch((e: any) => console.log(e));
  };



  if (!appointment)
    return (
      <h1 className="w-full flex justify-center text-red-500 font-bolder animate-pulse">
        {" "}
        Cargando...{" "}
      </h1>
    );

  return (
    <div className="max-w-3xl ">
      <PatientBasicInfo patient={appointment?.patient} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <StyledWrapper.FormContainer>

          {
            chosenRole !== 'RRHH_ABSENTEE' && (
              <>
                <div className="my-5">
                  <SearchSelectFetch
                    control={control}
                    name="molde"
                    label="Puestos (Exámenes sugeridos)"
                    disabled={Boolean(exam)}
                    fetchOptions={async () => {
                      return fetchAndFilterMoldes(
                        LavorisInstance,
                        appointment?.patient?.company?.id || companies[0]?.id || currentCompany?.id,
                        patientType,
                      );
                    }}
                    propertyLabel={"name"}
                    inputStyles="rounded w-full h-[50px] "
                  />

                  {molde && (
                    <div className="my-5">
                      <div className="mb-6">
                        <PillButton
                          text={molde.name || molde.position.name}
                          onClick={() => resetField("molde")}
                        />
                      </div>
                      <MoldeDetails molde={molde} />
                    </div>

                  )}
                </div>
                <SearchSelectFetch
                  control={control}
                  name="exam"
                  label="Examen"
                  fetchOptions={async () =>
                    LavorisInstance.ExamsMoldes.getExamsWithPracticesDataFilteredByPatientType(
                      patientType,
                    )
                  }
                  propertyLabel={"name"}
                  inputStyles="rounded w-full h-[50px]"
                  disabled={Boolean(molde)}
                />
                {exam && (
                  <div className="mb-6">
                    <div className="mb-6">
                      <PillButton
                        key={`exam-${exam.id}`}
                        text={exam.name}
                        onClick={() => resetField("exam")}
                      />
                    </div>
                    <ExamDetails exam={exam} />
                  </div>
                )}

              </>
            )
          }

          <SearchSelectFetch
            control={control}
            name="practiceSelector"
            label="Prácticas"
            fetchOptions={async () => {
              return fetchAndFilterPractices(
                LavorisInstance,
                exam,
                molde,
                practicesSelected,
                patientType
              );
            }}
            propertyLabel={"name"}
            inputStyles="rounded w-full h-[50px]"
            onSelected={(data) => {
              const selected = practicesSelected?.length
                ? practicesSelected
                : [];
              setValue("practicesSelected", [...selected, data]);
            }}
          />
          {practicesSelected?.length >= 0 && (
            <PracticesPillows
              practices={practicesSelected}
              onClick={(practice: Practice) => {
                setValue(
                  "practicesSelected",
                  practicesSelected.filter((p) => p.id !== practice.id),
                );
              }}
            />
          )}
          {practicesSelected?.some((p: Practice) => p.managerId === '1026') && (
            <>
              <hr />
              <InputRadioCM
                fieldName={"has_cm"}
                label={"¿Tiene Certificado Médico?"}
                register={register}
                error={errors.has_cm}
                required={true}
                getValues={getValues}
                setValue={setValue}
                readOnly={false}
                control={control}
              />
              <hr />
            </>
          )}
          {/* <StyledWrapper.HalfWidth>
            <DatePicker
              disabled={optionFailed}
              styles={`${optionFailed && "bg-gray-100"}`}
              fieldName="date"
              label={"Fecha de Turno"}
              minDate={1}
              maxDate={-5}
              control={control}
              required={!optionFailed}
              error={errors?.date}
              shouldDisableDate={(day: Date) =>
                !fechasUnicasDate.includes(day.toISOString().substr(0, 10))
              }
            />
          </StyledWrapper.HalfWidth> */}
          {/* <StyledWrapper.HalfWidth>
            <SearchSelectFetch
              required={!optionFailed}
              control={control}
              name="hour"
              label="Horario"
              fetchOptions={async () => {
                return slotsOptions.length > 0 && date
                  ? getTimesBySlotsOptions(slotsOptions, date)
                  : [];
              }}
              propertyLabel={"name"}
              disabled={optionFailed}
              inputStyles={` ${optionFailed ? "bg-gray-100" : ""}`}
            />
          </StyledWrapper.HalfWidth>
          {optionFailed ? <OptionsFailedAlert /> : null} */}
          <Textarea
            fieldName="comments"
            label="Comentarios"
            register={register}
            error={errors?.comments}
            styles="rounded w-full"
          />


          <StyledWrapper.ListItem>Adjunto:</StyledWrapper.ListItem>
          {/* <span> {downloadButton}</span> */}
          <DownloadButton id={id} updateUploadedFiles={updateUploadedFiles} />

        </StyledWrapper.FormContainer>
        <StyledWrapper.Footer>
          <div className="w-52">
            <PrimaryButton
              type={"submit"}
              text={"Editar Turno"}
              styles="bg-red-500 font-bold text-white"
              disabled={isLoading}
            />
          </div>
        </StyledWrapper.Footer>
      </form>
      {/* {isActive(WARNING) && (
        <ErrorWarningModal
          show
          urlTittle={WARNING}
          modalTitle={
            "Debes seleccionar una hora y fecha válida o cambiar tu selección antes de editar"
          }
          paramsToCleanOnClose={[WARNING]}
          onClose={() => closeModal(WARNING)}
        />
      )} */}
      {isActive(SUCCESS) && (
        <SuccessModal
          show
          urlTittle={SUCCESS}
          modalTitle={successMessages.title}
          modalSubtitle={successMessages.subTitle}
          onClose={() => {
            closeModal(SUCCESS);
            closeModal("modalEditTurn");
          }}
        />
      )}
    </div>
  );
}
